<template>
  <div class="refund-cancellation-component">
    <div class="section-2">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>

        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="">
            <p>
              We thank you and appreciate your subscription to our website.
              Please read the policy, conditions, and process carefully as they
              will give you important information and guidelines about your
              rights and obligations as our subscriber, concerning the
              subscription you make on our website. We make every effort to have
              our website meet your expectations
            </p>
            <h1>StockAnts has no refund policy.</h1>
          </div>

          <!-- <div class="special-sec">
            <h1>
              Terms of Cancellation and Refund: Subscription-based charges
            </h1>
            <ul>
              <li>
                A claim for cancellation can be made at any time during the
                subscription period.
              </li>
              <li>
                The cancellation request shall be processed only if the email
                requesting for such cancellation is received from the email
                address registered in your account. The email should be sent to
                admin@stockants.com
              </li>
              <li>
                StockAnts has no refund policy. You can cancel your subscription
                anytime as we charge on a Monthly basis only.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <h1>Terms of Cancellation and Refund: Data Download</h1>
            <ul>
              <li>
                No refund policy – Whenever a user downloads any data in CSV
                format, the amount based on data downloaded will be charged to
                the user instantly.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <p>
              <span class="font-weight-600 font-1rem">
                StockAnts will charge on monthly basis-</span
              >
              user will have to pay every month for selected plan
            </p>
          </div>

          <div class="special-sec">
            <p>
              <span class="font-weight-600 font-1rem"
                >Payment Intimation –</span
              >
              StockAnts will send payment reminder via registered email 5 days
              prior end of every month.
            </p>
          </div>

          <div class="special-sec">
            <p>
              <span class="font-weight-600 font-1rem"
                >Subscription will be cancelled –
              </span>
              if the user does not pay for the following month.
            </p>
          </div>

          <div class="special-sec">
            <p>
              <span class="font-weight-600 font-1rem">Free trial – </span> There
              is no free trial for any plans and data download. User will be
              charged instantly and can access unlimited post payment.
            </p>
          </div> -->
        </el-col>

        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
      </el-row>
    </div>
  </div> </template
><script>
export default {
  name: "RefundAndCancellationComponent",

  components: {},

  mixins: [],

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.refund-cancellation-component {
  .section-2 {
    .special-sec {
      margin: 60px 0;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: 600;
      color: #25246a;
    }
    p {
      font-size: 0.9rem;
      color: #6d6a6a;
    }
    ul {
      list-style: none;
      li {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #6d6a6a;
      }
      li::before {
        content: "\2022";
        color: #322e79;
        font-weight: bold;
        width: 1em;
        margin-left: -1em;
        font-size: 45px;
        position: relative;
        margin-right: 25px;
        top: 7px;
      }
    }
  }

  @media screen and (max-width: 876px) {
    .section-2 {
      padding: 0 70px;
    }
  }
  @media screen and (max-width: 600px) {
    .section-2 {
      padding: 0 35px;
    }
  }
  @media screen and (max-width: 450px) {
    .section-2 {
      padding: 0 20px;
    }
  }
}
</style>
